<template>
  <div class="locationadditionalinstructions">
    <v-layout row wrap>
      <v-flex xs12>
        <FormSectionTitle>Additional Instructions</FormSectionTitle>

        <div class="counter-textarea">
          <v-textarea
            ref="additionalInstructions"
            v-model="value.additionalInstructions"
            v-validate="InputValidations.propertyAdditionalInstructions"
            :counter="300"
            :error="errors.collect('Additional Instructions').length > 0"
            data-vv-name="Additional Instructions"
            label="Driving directions, property access info, or pet instructions."
            outline />
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Constants } from '@homegauge/vue';
import FormSectionTitle from '@/components/FormSectionTitle.vue';

const { InputValidations } = Constants;

const DEFAULT_MODEL = {
  additionalInstructions: '',
};
export default {
  components: {
    FormSectionTitle,
  },
  inject: ['$validator'],
  props: {
    value: {
      type: Object,
      default: () => DEFAULT_MODEL,
    },
  },
  data() {
    return {
      InputValidations,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/typography';

.counter-textarea {
  ::v-deep textarea {
    padding-bottom: 25px;
  }

  ::v-deep .v-input__control {
    position: relative;

    .v-input__slot {
      margin: 0;
      position: relative;
      z-index: 1;
    }

    .v-text-field__details {
      bottom: 5px;
      left: 0;
      margin: 0;
      position: absolute;
      z-index: 2;

      .v-counter {
        margin: 0;

        &.error--text {
          font-weight: $typography-weight-bold;
        }
      }
    }
  }
}
</style>
